import moment from "moment"

export function formatearHora(horasMoment) {


    return moment( horasMoment ).format( "HH:mm:ss" )

    // return [
    //     moment(horasMoment.entrada).format("HH:mm:ss"),
    //     moment(horasMoment.salida).format("HH:mm:ss")
    // ]

}

export const formatearFecha = ( fecha ) => moment(fecha).format('YYYY-MM-DD')

export function formatearHoraRango(rango) {
    return [
        moment(rango[0]).format('YYYY-MM-DD'),
        moment(rango[1]).format('YYYY-MM-DD')
    ]
}
